<script setup lang="ts">
import { onBeforeMount, onMounted, ref, inject, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { getCurrentLocale } from '@/i18n';
import { getTextVariant } from '@/utils/stringUtils';
import { TOUR } from '@/constants';
import Button from 'primevue/button';
import FlightLog from './Flight/FlightLog.vue';
import FlightRule from './Flight/FlightRule.vue';
import HotelLog from './hotels/HotelLog.vue';
import HotelRule from './hotels/HotelRule.vue';
import TourLog from './tour/TourLog.vue';

const dialogRef = inject('dialogRef') as Ref;
const ruleData = dialogRef?.value.data.ruleData;
const quoteType = dialogRef?.value.data.quoteType;
const childOptionValue = dialogRef?.value.data.childOptionValue;
const onClose = dialogRef?.value.options.emits.onClose;
const isFlightRule = dialogRef?.value.data.isFlightRule;
const groupTypeListValue = dialogRef?.value.data.groupTypeList;

const { t } = useI18n({ useScope: 'global' });
const currentLanguage = getCurrentLocale();
const expandedRows = ref([]);

const renderGroupType = () => {
  ruleData.hotelLog.forEach((hotel: any) => {
    hotel.groupTypes = groupTypeListValue?.filter((group: any) => hotel.groupTypes?.includes(group.sk)).map((data: any) => getTextVariant(currentLanguage, data['name'], data['nameFr']));
  });
};

onBeforeMount(() => {
  if (quoteType !== TOUR) {
    renderGroupType();
  }
});

onMounted(() => {
  expandedRows.value = quoteType !== TOUR ? ruleData.flightLog : ruleData.tourLog[childOptionValue].flightLog;
});
</script>
<template>
  <div class="preview-rule">
    <div>
      <div v-if="!isFlightRule">
        <div v-if="quoteType !== TOUR">
          <HotelLog :ruleData="ruleData"></HotelLog>
          <HotelRule :ruleData="ruleData"></HotelRule>
        </div>
        <TourLog v-else :option="ruleData.tourLog[childOptionValue]"></TourLog>
      </div>
      <div v-else>
        <FlightLog :option="quoteType !== TOUR ? ruleData : ruleData.tourLog[childOptionValue]" v-model:expandedRows="expandedRows"></FlightLog>
        <FlightRule :ruleData="quoteType !== TOUR ? ruleData : ruleData.tourLog[childOptionValue]"></FlightRule>
      </div>
      <div class="flex justify-content-center mt-2">
        <Button :label="t('common.buttons.close')" class="p-button" @click="onClose()" />
      </div>
    </div>
  </div>
</template>
